var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creator_main"},[_c('div',{staticClass:"creator_title"},[_vm._v(_vm._s(_vm.$t('creator')))]),_c('member-list-component',{attrs:{"member-type":'creator'}}),_c('br'),_c('transition',{attrs:{"name":`detail-${_vm.$root.$children[0].transitionName}`}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }